import { userFromFirestore } from '@parallel-fluidics/shared/models/users';
import useRealtimeDocs from 'hooks/use-realtimeDocs';
import { useMemo } from 'react';

import getSearchOrgUsersQuery from '../api/getSearchOrgUsersQuery';

export default function useRealtimeOrgUsers({ orgId, domainsStr }) {
  const usersQuery = useMemo(
    () => getSearchOrgUsersQuery({
      orgId,
      domainsStr,
    }),
    [orgId, domainsStr],
  );

  return useRealtimeDocs({
    query: usersQuery,
    transformData: userFromFirestore,
  });
}
